module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "学员基本信息",
      "width": "1000px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "on-click": _vm.onTabClick
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('Tab-pane', {
    attrs: {
      "label": "基本信息"
    }
  }, [_c('Form', {
    ref: "userInfoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.userRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "span": "14"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 14,
      "sm": 8,
      "md": 14
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "英文名字："
    }
  }, [_c('Input', {
    attrs: {
      "name": "enName"
    },
    model: {
      value: (_vm.formData.enName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enName", $$v)
      },
      expression: "formData.enName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "密码："
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "name": "enName"
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "中文名字："
    }
  }, [_c('Input', {
    attrs: {
      "name": "enName"
    },
    model: {
      value: (_vm.formData.cnName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cnName", $$v)
      },
      expression: "formData.cnName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "年龄：",
      "prop": "age"
    }
  }, [_c('Input', {
    attrs: {
      "name": "enName"
    },
    model: {
      value: (_vm.formData.age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "age", $$v)
      },
      expression: "formData.age"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "性别："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.sex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sex", $$v)
      },
      expression: "formData.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                          ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "年级："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }, _vm._l((_vm.$constant.grade), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                          ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "生日："
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.formData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formData, "birthday", _vm._n($$v))
      },
      expression: "formData.birthday"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 10,
      "sm": 8,
      "md": 7
    }
  }, [_c('a', {
    on: {
      "click": _vm.openStudentPage
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px",
      "height": "120px"
    },
    attrs: {
      "src": _vm.totalImageUrl
    }
  })]), _vm._v(" "), _c('single-one-pic-upload', {
    attrs: {
      "text": _vm.text
    },
    on: {
      "on-file-change": _vm.handleResult
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('i-col', [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "生源地："
    }
  }, [_c('v-distpicker', {
    attrs: {
      "province": _vm.formData.province,
      "city": _vm.formData.city,
      "area": _vm.formData.block,
      "placeholders": _vm.placeholders
    },
    on: {
      "province": _vm.onSelectedProvince,
      "city": _vm.onSelectedCity,
      "area": _vm.onSelectedArea
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "英语学习经历："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.learnEnglishTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "learnEnglishTime", $$v)
      },
      expression: "formData.learnEnglishTime"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("不足三个月")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("一年左右")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("一年以上")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("没有学习过英语")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "是否接触过外教："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.haveContactForeignTeacher),
      callback: function($$v) {
        _vm.$set(_vm.formData, "haveContactForeignTeacher", $$v)
      },
      expression: "formData.haveContactForeignTeacher"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "-1"
    }
  }, [_c('span', [_vm._v("否")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "家庭经济情况："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.familyEconomicSituation),
      callback: function($$v) {
        _vm.$set(_vm.formData, "familyEconomicSituation", $$v)
      },
      expression: "formData.familyEconomicSituation"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("非常好")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("一般")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("不是很好")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "是否重视英语学习："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.attentionEnglish),
      callback: function($$v) {
        _vm.$set(_vm.formData, "attentionEnglish", $$v)
      },
      expression: "formData.attentionEnglish"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("否")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 120,
      "label": "接通状态："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.connectionStatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "connectionStatus", $$v)
      },
      expression: "formData.connectionStatus"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("未拨打")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("拨打未接")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("拨打接通")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("无效资源")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 20px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("联系方式")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "学生ID："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.uid))])])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "手机号码：",
      "prop": "mobile"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formData.mobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mobile", $$v)
      },
      expression: "formData.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "号码对应人："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.phoneRole),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phoneRole", $$v)
      },
      expression: "formData.phoneRole"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("父亲")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("母亲")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("其他")])])], 1)], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addContact
    }
  }, [_vm._v("添加联系人")]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "userContacts"
    }
  }, _vm._l((_vm.formData.userContacts), function(item, index) {
    return _c('div', [_c('Row', {
      attrs: {
        "gutter": 22
      }
    }, [_c('Form-item', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('i-col', {
      attrs: {
        "span": "10"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "姓名"
      },
      model: {
        value: (_vm.formData.userContacts[index].name),
        callback: function($$v) {
          _vm.$set(_vm.formData.userContacts[index], "name", $$v)
        },
        expression: "formData.userContacts[index].name"
      }
    })], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "10"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "手机号码",
        "number": true
      },
      model: {
        value: (_vm.formData.userContacts[index].mobile),
        callback: function($$v) {
          _vm.$set(_vm.formData.userContacts[index], "mobile", $$v)
        },
        expression: "formData.userContacts[index].mobile"
      }
    })], 1), _vm._v(" "), _c('Button', {
      on: {
        "click": function($event) {
          return _vm.deleteContact(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)], 1)
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "微信账号：",
      "prop": "weChat"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.formData.weChat),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weChat", $$v)
      },
      expression: "formData.weChat"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "地址："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "个人信息备注："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.infoRemark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "infoRemark", $$v)
      },
      expression: "formData.infoRemark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "span": "14"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("学生来源标签")])], 1), _vm._v(" "), _c('Form-item', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "label-width": 80,
      "label": "注册渠道："
    }
  }, [_c('Input', {
    attrs: {
      "name": "regType",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.regType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "regType", $$v)
      },
      expression: "formData.regType"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('i-col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 77,
      "label": "付费渠道："
    }
  }, _vm._l((_vm.$constant.studentTags), function(item) {
    return _c('RadioGroup', {
      model: {
        value: (_vm.formData.payCanal),
        callback: function($$v) {
          _vm.$set(_vm.formData, "payCanal", $$v)
        },
        expression: "formData.payCanal"
      }
    }, [_c('Radio', {
      attrs: {
        "label": item.code
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("课顾电话跟进")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 22
    }
  }, [_c('i-col', {
    attrs: {
      "span": "20"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("意向等级：")]), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.formData.intentLevel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "intentLevel", $$v)
      },
      expression: "formData.intentLevel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("不论")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("高意向")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("意向一般")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("待跟进")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("无效资源")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "height": "326px",
      "border-bottom": "1px dotted #ddd"
    },
    attrs: {
      "span": "9"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "30px",
      "margin-bottom": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("学生属性标签")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '学习经历') ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "margin": "0 0 10px 40px"
      }
    }, [_vm._v("学习经历:\n                    "), _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '英语水平') ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "margin": "0 0 10px 40px"
      }
    }, [_vm._v("英语水平:\n                  "), _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '孩子性格') ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "margin": "0 0 10px 40px"
      }
    }, [_vm._v("孩子性格:\n                    "), _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '兴趣爱好') ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "margin": "0 0 10px 40px"
      }
    }, [_vm._v("兴趣爱好:\n                  "), _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    })], 2) : _vm._e()
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return (key == '老师要求') ? _c('span', {
      staticStyle: {
        "margin-left": "40px",
        "font-size": "15px"
      }
    }, [_vm._v("老师要求:\n                   "), (val != null) ? _c('span', _vm._l((val), function(item) {
      return _c('Tag', {
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    }), 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n                     无\n                   ")])]) : _vm._e()
  }), 0)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "telephone"
  }, [_c('Button', {
    attrs: {
      "shape": "circle"
    },
    on: {
      "click": _vm.dialTel
    }
  })], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "i-columns": _vm.title,
      "data": _vm.telDetails
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.addStudent
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    staticClass: "cancel",
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "follow up"
    }
  }, [_c('Form', {
    ref: "followForm",
    staticClass: "form",
    attrs: {
      "model": _vm.followFormData,
      "rules": _vm.followRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("follow up")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.id) + " -- " + _vm._s(_vm.followFormData.nickname))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.adviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.studyAdviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定老师：",
      "label-width": 80
    }
  }, _vm._l((_vm.followFormData.tchNames), function(tchName) {
    return _c('label', [_vm._v(_vm._s(tchName)), _c('br')])
  }), 0)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容：",
      "prop": "content",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.followFormData.content),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "content", $$v)
      },
      expression: "followFormData.content"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态：",
      "prop": "traceStatus",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeFollow
    },
    model: {
      value: (_vm.followFormData.traceStatus),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "traceStatus", $$v)
      },
      expression: "followFormData.traceStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("高跟进")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("跟进中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("跟进低")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("无意向")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("多次联系不到")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("注册备注")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 50,
      "prop": "traceItem"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.followFormData.traceItem),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "traceItem", $$v)
      },
      expression: "followFormData.traceItem"
    }
  }, _vm._l((_vm.followList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.followFormData.traceStatus == 100 || _vm.followFormData.traceStatus == '100') ? _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "label-width": 80
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100
    },
    model: {
      value: (_vm.followFormData.files),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "files", $$v)
      },
      expression: "followFormData.files"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系时间：",
      "prop": "nextDate",
      "label-width": 80
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.changeDate
    },
    model: {
      value: (_vm.nextDate),
      callback: function($$v) {
        _vm.nextDate = $$v
      },
      expression: "nextDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "对老师要求：",
      "label-width": 80
    }
  }, [_c('ElSwitch', {
    model: {
      value: (_vm.askForTch),
      callback: function($$v) {
        _vm.askForTch = $$v
      },
      expression: "askForTch"
    }
  })], 1), _vm._v(" "), (_vm.askForTch) ? [_c('Form-item', {
    attrs: {
      "label": "对学生描述：",
      "label-width": 80
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini",
      "max": 3
    },
    model: {
      value: (_vm.followFormData.stuDescCheckGroup),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "stuDescCheckGroup", $$v)
      },
      expression: "followFormData.stuDescCheckGroup"
    }
  }, _vm._l((_vm.$constant.stuDesc), function(item) {
    return _c('el-checkbox', {
      key: item.code,
      attrs: {
        "label": item.code,
        "border": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "对老师要求：",
      "label-width": 80
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini",
      "max": 5
    },
    model: {
      value: (_vm.followFormData.askForTchCheckGroup),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "askForTchCheckGroup", $$v)
      },
      expression: "followFormData.askForTchCheckGroup"
    }
  }, _vm._l((_vm.$constant.askForTch), function(item) {
    return _c('el-checkbox', {
      key: item.code,
      attrs: {
        "label": item.code,
        "border": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 0 40px 35px"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addFollow
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("follow up记录")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.followtitle,
      "data": _vm.followData,
      "reload": _vm.reload
    }
  })], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "推荐老师"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openRecommendEdit
    }
  }, [_vm._v("添加老师")]), _vm._v(" "), _c('RecommendList', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "uid": _vm.formData.uid,
      "listUrl": "/tchRecommend/list",
      "tableColumns": _vm.recommendTitle,
      "reset": _vm.reset,
      "data": _vm.recommendData
    }
  })], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "阶段报告"
    }
  }, [_c('Table', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "border": "",
      "columns": _vm.stageReportTitle,
      "data": _vm.stageReportData,
      "reload": _vm.reload
    }
  })], 1), _vm._v(" "), _c('Tab-pane', {
    attrs: {
      "label": "学生跟踪记录"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "maxlength": 10,
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formValidate.content),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "content", $$v)
      },
      expression: "formValidate.content"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "size": "small",
      "loading": _vm.aiLoading,
      "disabled": _vm.aiLoading
    },
    on: {
      "click": _vm.handleAiMarkdown
    }
  }, [_vm._v("AI 处理")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("将通话/听记原文清洗为结构化 Markdown")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "clearable": false
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    },
    model: {
      value: (_vm.formValidate.nextTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextTimeDate", $$v)
      },
      expression: "formValidate.nextTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "记录属性",
      "prop": "traceType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.traceType),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "traceType", $$v)
      },
      expression: "formValidate.traceType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("分配记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("试听课记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("成交记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("交接记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v("绑定记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "61"
    }
  }, [_vm._v("上课跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "71"
    }
  }, [_vm._v("转介绍跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formValidate.files),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "files", $$v)
      },
      expression: "formValidate.files"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "track-list",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("记录属性")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "16%"
    }
  }, [_vm._v("添加时间")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("内容")]), _vm._v(" "), _c('th', {
    staticClass: "next-handler-time-col"
  }, [_vm._v("下次联系日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("下次联系人")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("操作人")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": item.rowSpan,
        "hidden": item.hidden
      }
    }, [_vm._v(_vm._s(item.showName))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('td', [_c('TrackContentPreview', {
      attrs: {
        "content": item.content
      },
      on: {
        "view": function($event) {
          return _vm.openTrackContent(item)
        }
      }
    }, [(item.showName == '注册学员备注' && item.nickname && item.nickname.trim() !== '') ? _c('a', {
      staticStyle: {
        "margin-left": "8px"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.viewPic(item)
        }
      }
    }, [_vm._v("查看图片")]) : _vm._e()])], 1), _vm._v(" "), _c('td', {
      staticClass: "next-handler-time-col"
    }, [_c('span', {
      staticClass: "next-handler-time-text",
      attrs: {
        "title": _vm.formatNextHandlerTime(item)
      }
    }, [_vm._v(_vm._s(_vm.formatNextHandlerTime(item)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nextHandlerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.createName))])])
  }), 0)]), _vm._v(" "), _c('Page', {
    attrs: {
      "total": _vm.traceParam.totalCount,
      "show-elevator": "",
      "className": "page",
      "current": _vm.traceParam.pageIndex,
      "pageSize": _vm.traceParam.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('RecommendTeacher', {
    attrs: {
      "value": _vm.recommendEdit,
      "uid": _vm.formData.uid
    },
    on: {
      "on-close": _vm.closeRecommendEdit
    }
  }), _vm._v(" "), _c('StageReportModal', {
    attrs: {
      "uid": _vm.formData.uid,
      "successCallback": _vm.reportList
    },
    model: {
      value: (_vm.StageReportModal),
      callback: function($$v) {
        _vm.StageReportModal = $$v
      },
      expression: "StageReportModal"
    }
  }), _vm._v(" "), _c('EvaluationSheetModal', {
    attrs: {
      "reprotId": _vm.reprotId,
      "successCallback": _vm.reportList
    },
    on: {
      "on-close": _vm.onEvaluationSheetModalClose
    },
    model: {
      value: (_vm.showEvaluationSheetModal),
      callback: function($$v) {
        _vm.showEvaluationSheetModal = $$v
      },
      expression: "showEvaluationSheetModal"
    }
  }), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('UserTrackContentModal', {
    ref: "trackContentModal"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c474bea0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/UserInfoModal.vue
// module id = 1949
// module chunks = 8